import tw, { styled } from 'twin.macro';

const EmptyAssetWrapper = styled.div(() => [
  tw`
    flex justify-center items-center p-4 bg-gray-100 rounded-md text-gray-600 font-medium text-sm
  `,
]);

export default EmptyAssetWrapper;
